/**
 * 連続スクロール表示のレイアウト計算
 *
 * 画像や未読み込みの章の仮の高さで、スクロール量の比率と本文の文字数の比率は一致しない。
 * そこで本文の位置は、実際に並んだ章の位置と長さから求める。
 */

/** スクロールできる長さ（縦書きは横、横書きは縦） */
export const scrollMaxOf = (container: HTMLElement, vertical: boolean): number =>
  vertical ? container.scrollWidth - container.clientWidth : container.scrollHeight - container.clientHeight

/** 先頭側の端（縦書きは右端）からの現在のスクロール量 */
export const scrollPosOf = (container: HTMLElement, vertical: boolean): number =>
  vertical ? Math.abs(container.scrollLeft) : container.scrollTop

export type SectionExtent = { start: number; size: number }

/** 本の先頭側の端を 0 としたときの、各章の位置と長さ（章のラッパーは data-section-index を持つ） */
export const measureSections = (container: HTMLElement, vertical: boolean): SectionExtent[] => {
  const containerRect = container.getBoundingClientRect()
  const scrolled = scrollPosOf(container, vertical)
  return Array.from(container.querySelectorAll<HTMLElement>('[data-section-index]'), (el) => {
    const rect = el.getBoundingClientRect()
    return vertical
      ? { start: scrolled + containerRect.right - rect.right, size: rect.width }
      : { start: scrolled + rect.top - containerRect.top, size: rect.height }
  })
}

export const clamp01 = (value: number): number => Math.min(Math.max(value, 0), 1)

/** スクロール量の位置にある章の番号と、その章の中の進み具合（0〜1） */
export const locateScroll = (
  extents: SectionExtent[],
  scrollPos: number,
): { index: number; progression: number | undefined } => {
  let index = 0
  extents.forEach((extent, i) => {
    if (extent.start <= scrollPos + 1) index = i
  })
  const extent = extents.at(index)
  const progression = extent && extent.size > 0 ? clamp01((scrollPos - extent.start) / extent.size) : undefined
  return { index, progression }
}
